import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {PoiType} from "../types/PoiType";
import {SWITCHER_POI_CONFIG} from "../utils/poi_type_utils";

export type AmplitudeMapLayersFilterTrigger = "automatic" | "manual";

export type AmplitudeMapLayersLocation = "property_page" | "investment_page";

const POI_TYPE_TO_MAP_LAYER: Partial<Record<PoiType, string>> = {
    [PoiType.OFFERS]: "investments",
    [PoiType.TRANSPORT]: "transit",
    [PoiType.EDUCATION]: "education",
    [PoiType.SHOPS]: "shops",
    [PoiType.SPORT]: "sport",
    [PoiType.HEALTH]: "health",
    [PoiType.ENTERTAINMENT]: "playgrounds",
    [PoiType.FOOD]: "cafes_restaurants"
};

const WALK_SPEED_KM_PER_HOUR = 4;

export const getAmplitudeMapRadius = (distanceInKilometers: number): string => `${Math.round((distanceInKilometers / WALK_SPEED_KM_PER_HOUR) * 60)}_min_walk`;

export const getAmplitudeMapLayers = (checkedPoiTypes: PoiType[]): string | null => {
    const activeLayers = SWITCHER_POI_CONFIG.filter(({type}) => checkedPoiTypes.includes(type))
        .map(({type}) => POI_TYPE_TO_MAP_LAYER[type])
        .filter((layer): layer is string => Boolean(layer));

    return activeLayers.length > 0 ? activeLayers.join("|") : null;
};

interface ITrackAmplitudeMapLayersAppliedParams {
    filterTrigger: AmplitudeMapLayersFilterTrigger;
    checkedPoiTypes: PoiType[];
    poiDistance: number;
    location: AmplitudeMapLayersLocation;
    itemId: number;
    propertyId?: number | null;
}

export const trackAmplitudeMapLayersApplied = (params: ITrackAmplitudeMapLayersAppliedParams): void => {
    trackAmplitudeEvent("map_layers_applied", {
        filter_trigger: params.filterTrigger,
        map_layers: getAmplitudeMapLayers(params.checkedPoiTypes),
        map_radius: getAmplitudeMapRadius(params.poiDistance),
        location: params.location,
        item_id: params.itemId,
        property_id: params.propertyId ?? null
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {PoiType} from "../types/PoiType";
import {SWITCHER_POI_CONFIG} from "../utils/poi_type_utils";

export type AmplitudeMapLayersFilterTrigger = "automatic" | "manual";

export type AmplitudeMapLayersLocation = "property_page" | "investment_page";

const POI_TYPE_TO_MAP_LAYER: Partial<Record<PoiType, string>> = {
    [PoiType.OFFERS]: "investments",
    [PoiType.TRANSPORT]: "transit",
    [PoiType.EDUCATION]: "education",
    [PoiType.SHOPS]: "shops",
    [PoiType.SPORT]: "sport",
    [PoiType.HEALTH]: "health",
    [PoiType.ENTERTAINMENT]: "playgrounds",
    [PoiType.FOOD]: "cafes_restaurants"
};

const WALK_SPEED_KM_PER_HOUR = 4;

export const getAmplitudeMapRadius = (distanceInKilometers: number): string => `${Math.round((distanceInKilometers / WALK_SPEED_KM_PER_HOUR) * 60)}_min_walk`;

export const getAmplitudeMapLayers = (checkedPoiTypes: PoiType[]): string | null => {
    const activeLayers = SWITCHER_POI_CONFIG.filter(({type}) => checkedPoiTypes.includes(type))
        .map(({type}) => POI_TYPE_TO_MAP_LAYER[type])
        .filter((layer): layer is string => Boolean(layer));

    return activeLayers.length > 0 ? activeLayers.join("|") : null;
};

interface ITrackAmplitudeMapLayersAppliedParams {
    filterTrigger: AmplitudeMapLayersFilterTrigger;
    checkedPoiTypes: PoiType[];
    poiDistance: number;
    location: AmplitudeMapLayersLocation;
    itemId: number;
    propertyId?: number | null;
}

export const trackAmplitudeMapLayersApplied = (params: ITrackAmplitudeMapLayersAppliedParams): void => {
    trackAmplitudeEvent("map_layers_applied", {
        filter_trigger: params.filterTrigger,
        map_layers: getAmplitudeMapLayers(params.checkedPoiTypes),
        map_radius: getAmplitudeMapRadius(params.poiDistance),
        location: params.location,
        item_id: params.itemId,
        property_id: params.propertyId ?? null
    });
};
